import React from 'react';
import Isvg from 'react-inlinesvg';

import xIcon from '../assets/svg/x.svg';
import {
    Modal, ModalBody, ModalFooter, Button,
    ModalHeader
} from 'reactstrap';


/**
* Preview item modal
* @author   Andrej Stjepanovic
*/
class PreviewModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { isOpen, lang, toggle, title, children, className, beforeCloseButton, pdfUrl, hideCloseButton } = this.props;

        return (

            <Modal isOpen={isOpen} centered className={className || ""}>
                <ModalHeader className="preview-modal-header" close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => toggle()}><Isvg src={xIcon} /></button>}>
                    {title}
                </ModalHeader>
                <ModalBody>
                    <div className='preview-modal-body'>
                        {children}
                    </div>
                </ModalBody>
                <ModalFooter className="buttons-right-blue" style={{ justifyContent: 'flex-end' }}>
                    {
                        pdfUrl && <a href={pdfUrl} download target="_blank" rel="noopener noreferrer">
                            <Button type="button" className="button-blue">{'Save as pdf'.translate(lang)}</Button>
                        </a>
                    }
                    {beforeCloseButton}
                    {!hideCloseButton && <Button type="button" className="button-blue" onClick={() => toggle()} >{'Close'.translate(lang)}</Button>}
                </ModalFooter>
            </Modal>
        )
    }
}

export default PreviewModal;